<template>
    <div>
        <v-app-bar-nav-icon
            class="filter-btn"
            @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <v-navigation-drawer
            v-model="drawer"
            class="drawer"
            width="220"
            height="100%"
            app
            style="top:0; left:0; overflow-y:auto;"
        >
            <v-img
                :aspect-ratio="1"
                width="175"
                src="/Content/img/ssv-logo.svg"
                class="drawer__logo"
            />
            <reset-filters :show="anySelectedFilters"></reset-filters>
            <span class="headline d-block mx-12 mx-lg-2 mt-2">Filters</span>

            <v-list class="filter px-8 px-lg-0">
                <v-list-group
                    v-for="(item, index) in visibleFilters"
                    :key="index"
                    v-model="item.active"
                    color="white"
                    :prepend-icon="item.action"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title
                                :class="
                                    item.children.some(x => x.active) &&
                                    !item.active
                                        ? 'has-active-children'
                                        : ''
                                "
                                v-text="item.name"
                            ></v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item-group>
                        <v-list-item
                            v-for="option in item.children"
                            :key="option.id"
                            :class="{ 'is-active': option.active }"
                            @click="
                                changeActiveStateAndTellTheParent(
                                    item.name,
                                    option
                                )
                            "
                        >
                            <v-list-item-content>
                                <v-list-item-title
                                    v-text="option.name"
                                ></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list-group>
            </v-list>
            <reset-filters :show="anySelectedFilters"></reset-filters>
        </v-navigation-drawer>
    </div>
</template>

<script>
import { EventBus } from '../../components/helpers/eventbus';
import ResetFilters from '@/views/LayoutElement/reset-filters';
export default {
    components: {
        ResetFilters
    },
    props: {
        value: {
            type: Array,
            default() {
                return [];
            }
        },
        filters: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            active: [],
            open: [],
            drawer: true
        };
    },

    computed: {
        visibleFilters() {
            return this.filters.filter(item => item.visible);
        },
        anySelectedFilters() {
            return (
                this.filters.filter(
                    item => item.children.filter(x => x.active).length > 0
                ).length > 0
            );
        }
    },
    created() {
        if (window.innerWidth < 1264) this.drawer = false;
        else this.drawer = true;
    },

    methods: {
        resetFilters() {
            EventBus.$emit('reset-filters');
        },
        changeActiveStateAndTellTheParent(name, option) {
            const selectedFilterOption = this.filters.find(x => x.name == name);
            const activeFilter = option.active;
            if (typeof selectedFilterOption != 'undefined') {
                if (!selectedFilterOption.allowMultiple) {
                    selectedFilterOption.children.forEach(
                        childNode => (childNode.active = false)
                    );
                }
                if (!activeFilter || selectedFilterOption.allowMultiple) {
                    option.active = !option.active;
                }
                EventBus.$emit('update-subscriptions');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.drawer {
    width: 100% !important;

    @include media-breakpoint-up(lg) {
        width: 220px !important;
    }
}

.drawer .headline {
    border-bottom: 2px solid #7fd060;

    @include media-breakpoint-up(lg) {
        color: #ffffff;
        border: 0;
    }
}

.theme--light.v-list {
    color: #ffffff;
}

.has-active-children,
.is-active .v-list-item__title {
    margin-left: 20px;
    transition: 0.2s;
    &::before {
        content: '✔';
        color: #7fd060;
        position: absolute;
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-left: -20px;
        transition: 0.2s;
    }
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled),
.v-list-item__title {
    color: #000000 !important;

    @include media-breakpoint-up(lg) {
        color: #ffffff !important;
    }
}

.v-list::v-deep .v-list-item .v-icon {
    color: #7fd060;

    @include media-breakpoint-up(lg) {
        color: #ffffff;
    }
}

.v-list::v-deep .v-list-item--link:last-of-type {
    padding-bottom: 15px;
}

.v-list::v-deep .v-list-item--link:before {
    background: none !important;
}

.v-list-group__items .v-list-item__title {
    font-style: italic;
}

.v-list::v-deep .v-list-group__items {
    padding-left: 10px;
}

.v-list::v-deep .v-list-item {
    min-height: 35px;
}

.filter-btn {
    position: fixed;
    top: 17px;
    left: 10px;
    z-index: 100;

    @include media-breakpoint-up(lg) {
        display: none;
    }
}

.drawer {
    background-color: rgba(255, 255, 255, 0.9);

    @include media-breakpoint-up(lg) {
        background: linear-gradient(
            198deg,
            #6bb743,
            #3287b3 32%,
            #de0a7d 91%,
            #e63a64 100%
        );
    }
}

.drawer__logo {
    position: relative;
    z-index: 10;
    margin: 0 auto;

    @include media-breakpoint-up(lg) {
        margin: 50px auto;
    }
}
</style>
